import { userInfoGet, userInfoGetRes } from '@/api/user-info';
import { tenantTokenName } from '@/config';
import { defineStore } from 'pinia';
import { setStorage } from 'xag-ai-utils';

interface State {
  user: userInfoGetRes['data'];
  loadUser: boolean;
  homePageRefresh: boolean;
}

// useStore could be anything like useUser, useCart
// the first argument is a unique id of the store across your application
export const useHeaderStore = defineStore<
  string,
  State,
  any,
  {
    fetchUserInfo: () => Promise<void>;

    resetApp: () => void;
    setHomePageRefresh: (val: boolean) => void;
  }
>('headerApp', {
  state: () => {
    return {
      user: null,
      homePageRefresh: false,
      loadUser: false,
    };
  },
  getters: {},
  actions: {
    async fetchUserInfo() {
      const { data } = await userInfoGet();
      this.user = data;

      sessionStorage.setItem(tenantTokenName, data.iamTenantId);
      setStorage('userInfoVO', data);
      this.loadUser = true;
    },

    setHomePageRefresh(val: boolean) {
      this.homePageRefresh = val;
    },

    resetApp() {
      this.user = null;
      this.loadUser = false;
    },
  },
});
